import { FaChartPie } from "react-icons/fa";
import { PeriodProvider } from "@/providers/Period";
import { lazy } from "react";

const EntradasDashboard = lazy(() => import("./Dashboard").then((m) => ({ default: m.EntradasDashboard })));
const RelatorioRecebimento = lazy(() => import("./RelatorioRecebimento"));
const EmbalagemEdit = lazy(() => import("./Produtos/FormEdit/edit").then((m) => ({ default: m.EmbalagemEdit })));
const EmbalagemCreate = lazy(() => import("./Produtos/FormEdit/create").then((m) => ({ default: m.EmbalagemCreate })));
const ProductEdit = lazy(() => import("./Produtos/FormProduct/edit").then((m) => ({ default: m.ProductEdit })));
const GestaoRecebimento = lazy(() => import("./GestaoRecebimento"));
const EntradaFornecedor = lazy(() => import("./Fornecedores"));
const EntradaGrupo = lazy(() => import("./Grupo"));
const GrupoDetails = lazy(() => import("./Grupo/Components/Details").then((m) => ({ default: m.GrupoDetails })));
const EntradaSubGrupo = lazy(() => import("./Subgrupos"));
const EntradaProduto = lazy(() => import("./Produtos"));
const ProdutosDetails = lazy(() => import("./Produtos/components/Details").then((m) => ({ default: m.ProdutosDetails })));
const Operacional = lazy(() => import("./Operacional"));
const PainelNotaFiscal = lazy(() => import("./PainelNotaFiscal"));
const GestaoQuarentena = lazy(() => import("./GestaoQuarentena").then((m) => ({ default: m.GestaoQuarentena })));
const AcompanhamentoProducao = lazy(() => import("./AcompanhamentoProducao").then((m) => ({ default: m.AcompanhamentoProducao })));


const Module = {
  menuItem: {
    to: "/entradas",
    title: "Entradas",
    icon: FaChartPie,
    id: 7,
    childrens: [
      {
        to: "entradas/dash",
        title: "Dashboard",
        fullTitle: "Dashboard",
        id: 18,
      },
      {
        to: "/entradas/consulta-de-fornecedores",
        title: "Fornecedores",
        fullTitle: "Consulta de Fornecedores",
        id: 19,
      },
      {
        to: "/entradas/gestao-de-recebimento",
        title: "Gestao",
        fullTitle: "Gestao de Recebimento",
        id: 20,
      },
      {
        to: "/entradas/operacional",
        title: "Operacional",
        fullTitle: "Operacional",
        id: 21,
      },
      {
        to: "/entradas/relatorio-recebimento",
        title: "Relatorio de Recebimento",
        fullTitle: "Relatorio de Recebimento",
        id: 22,
      },
      {
        to: "/entradas/consulta-de-grupos",
        title: "Grupos",
        fullTitle: "Consulta de Grupos",
        id: 23,
      },
      {
        to: "/entradas/consulta-de-subgrupos",
        title: "Subgrupos",
        fullTitle: "Consulta de Subgrupos",
        id: 24,
      },
      {
        to: "/entradas/consulta-de-produtos",
        title: "Produtos",
        fullTitle: "Consulta de Produtos",
        id: 25,
      },
      {
        to: "/entradas/painel-nota-fiscal",
        title: "Painel Operador Logistico",
        fullTitle: "Painel Operador Logistico",
        id: 81,
      },
      {
        to: "/entradas/gestao-quarentena",
        title: "Gestão Quarentena",
        fullTitle: "Gestão Quarentena",
        id: 26,
      },
      {
        to: "/entradas/acompanhamento-producao",
        title: "Relatório de Produção",
        fullTitle: "Relatório de Produção",
        id: 27,
      },
    ],
  },

  routes: [
    {
      path: "/entradas/gestao-de-recebimento",
      element: (
        <PeriodProvider>
          <GestaoRecebimento />
        </PeriodProvider>
      ),
    },
    {
      path: "/entradas/operacional",
      element: (
        <PeriodProvider>
          <Operacional />
        </PeriodProvider>
      ),
    },
    {
      path: "/entradas/relatorio-recebimento",
      element: <RelatorioRecebimento />,
    },
    {
      path: "entradas/dash",
      element: (
        <PeriodProvider>
          <EntradasDashboard />
        </PeriodProvider>
      ),
    },
    {
      path: "entradas/consulta-de-fornecedores",
      element: <EntradaFornecedor />,
      children: [{ path: ":id", element: <EntradaFornecedor /> }],
    },
    {
      path: "entradas/consulta-de-grupos",
      element: <EntradaGrupo />,
      children: [{ path: ":id", element: <GrupoDetails /> }],
    },
    {
      path: "entradas/consulta-de-subgrupos",
      element: <EntradaSubGrupo />,
    },
    {
      path: "entradas/consulta-de-produtos",
      element: <EntradaProduto />,
      children: [
        { path: ":id", element: <ProdutosDetails /> },
        { path: ":id/editar", element: <ProductEdit /> },
        {
          path: ":id/embalagem/criar",
          element: <EmbalagemCreate />,
        },
        {
          path: "embalagem/:embalagem",
          element: <EmbalagemEdit />,
        },
      ],
    },
    {
      path: "entradas/painel-nota-fiscal",
      element: (
        <PeriodProvider>
          <PainelNotaFiscal />
        </PeriodProvider>
      ),
    },
    {
      path: "/entradas/gestao-quarentena",
      element: <GestaoQuarentena />,
    },
    {
      path: "/entradas/acompanhamento-producao",
      element: <AcompanhamentoProducao />,
    },
  ],
};

export default Module;
